<template>
  <div class="form-group row">
    <div class="col-sm-2 text-sm-right">
      <label>Nome:</label>
    </div>
    <div class="col-md-4 col-sm-11 mb-3">
      <input type="text" class="form-control" v-model="filtro.nome">
    </div>

    <div class="col-sm-2 text-sm-right">
      <label>CNPJ / IE:</label>
    </div>
    <div class="col-md-3 col-sm-11 mb-3">
      <input type="text" class="form-control" v-model="filtro.cnpj">
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="consultar"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
    </div>
  </div>
</template>

<script>
import InteressadoService from '@/services/InteressadoService'
import eventBus from '@/uteis/eventBus'
import DataValues from '@/components/data-table-consulta/DataValues'

export default {
  props: {
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      filtro: {
        tipoInteressado: 'PESSOAJURIDICA',
        cnpj: '',
        nome: '',
        range: 5
      },
      columns: [
        [
          { key: 'nome', title: 'Nome' },
          { key: 'tipoContatoExterno', title: 'Tipo', converter: 'tipoContatoExterno' }
        ], [
          { key: 'identificador', title: 'Identificador' },
          { key: 'email', title: 'Email' }
        ]
      ]
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.consultar(numeroPagina)
    })

    this.service = new InteressadoService()
    this.consultar()
  },

  methods: {
    consultar (page = 1) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtro = {
        ...this.filtro,
        offset: page,
        idDepartamento: dadosSessao.sessao.idDepartamento
      }

      this.service.consultarInteressado(this.filtro).then(res => {
        if (res.data.data.length !== 0) {
          return eventBus.$emit(this.eventBusDataName, {
            ...res.data,
            id: 'id',
            columns: this.columns
          })
        }

        this.consultarEmpresa()
      }).catch(err => {
        console.log(err)
      })
    },

    consultarEmpresa () {
      this.service.buscarEmpresa(this.filtro).then((data) => {
        const dataValues = new DataValues([data], 1, 10)
        eventBus.$emit(this.eventBusDataName, {
          ...dataValues,
          id: 'id',
          columns: this.columns
        })
      }).catch(err => {
        if (err.config.message === 'Request failed with status code 500') {
          const dataValues = new DataValues([], 1, 10)
          eventBus.$emit(this.eventBusDataName, dataValues)
        }
      })
    },

    limpar () {
      this.filtro = {
        ...this.filtro,
        cnpj: '',
        nome: ''
      }
      this.consultar()
    }
  }
}
</script>
